import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { PaymentElement } from "@stripe/react-stripe-js";

import type { PaymentFormProps } from "./PaymentForm";

const LabelText = styled.div`
    font-size: 16px;
    font-weight: 600
    letter-spacing: -0.02em;
    line-height: 1.6;
    color: #222;
`;

const ErrorMessage = styled.div`
    color: white;
    background: orangered;
    letter-spacing: 0px;
    padding: 8px 15px;
    margin-top: 20px;
    font-size: 15px;
    font-weight: 600;
    display: inline-block;
`;

export function PaymentForm({ paymentMethodCreationError, handlePaymentElementChange }: PaymentFormProps) {
    const { t } = useTranslation();
    return (<>
        <LabelText>{t("Payment details")}</LabelText>

        <PaymentElement
            onChange={handlePaymentElementChange}
            options={{
                layout: {
                    type: "tabs",
                    defaultCollapsed: false
                },
                wallets: {
                    applePay: "auto",
                    googlePay: "never",
                    link: "auto",
                },
                fields: {
                    billingDetails: {
                        address: {
                            country: "never",
                            postalCode: "never"
                        }
                    }
                }
            }}
        />
        {paymentMethodCreationError &&
            <ErrorMessage>{paymentMethodCreationError}</ErrorMessage>
        }
    </>);
}
